import React from 'react';
import { FormControlLabel } from '@material-ui/core';
import styled from '@emotion/styled';
import { Magnetic as Mi } from "../../../styles";
import { defaultTranslateFn } from "../../../common";
const StyledCheckboxLabel = styled('label', {
    shouldForwardProp: prop => prop !== 'isBold'
}) `
	font-size: ${Mi.fontSize14};
	color: ${Mi.colorNeutral70};
	padding-left: ${Mi.spacer20};
	cursor: pointer;
	user-select: none;
	${({ isBold }) => isBold && `font-weight: ${Mi.fontWeightSemibold};`}
`;
const StyledCheckBoxIcon = styled('span') `
	font-size: ${Mi.fontSize18};
	color: ${Mi.checkboxRadioCoreIconColor};
`;
export const FormControlCheckBox = ({ id, isChecked, onChange, label, value, isReadOnly, isBold, translateFn = defaultTranslateFn }) => {
    return (React.createElement(FormControlLabel, { control: React.createElement(React.Fragment, null,
            React.createElement("input", { type: "checkbox", id: `form-control-label_checkbox_${id}`, checked: isChecked, onChange: onChange, name: value, readOnly: isReadOnly || false }),
            React.createElement(StyledCheckBoxIcon, { className: isChecked ? 'mi-icon-checkbox-checked' : 'mi-icon-checkbox' })), label: React.createElement(StyledCheckboxLabel, { isBold: isBold }, translateFn(label)) }));
};
//# sourceMappingURL=FormControlCheckBox.js.map